export const defaultTelMask = '+99 999999999';
export const defaultTelPlaceholder = 'Exemple : +33 123456789';
export const defaultEmailPlaceholder = 'Exemple : prenom.nom@domaine.com';
